const quotes = [
  {
      "quote": "Whatever seems like coincidence, rarely is.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "I’ve never seen a point in apologizing for other people’s actions.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "We can handle whatever the world drops on us.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "\u2026There are just some things you’ve got to see to believe. But I guess you’ve seen some of those things now, too.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "That’s what this world does to you. It takes you. Owns you.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "If there’s anything at all you care about, do something different with your life. Don’t let this world have you.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "Maybe all their fears were imagined, because life is never rainbows and happy endings, and maybe just this once, things will be different.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "You go search in romance. I’ll take horror.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "So, this is where you want to ask me the story of my life? Right here in this lot? It’s kind of cold for all that.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "Oldest story in the book.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "Nothing but numbness and solitude after that, going entire days without remembering to speak, the world a blur of people moving past her while her inner demons screamed that she was living alone and would die alone.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "It was only after she accepted that awful truth, internalized it, that she found clarity, the gray light at the end of the tunnel that she needed to go on with her new life.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "It’s the face of a man resigned to his fate, a man watching the tragedy of his own life who knows how it will end and that this is the final act.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "And for the first time, she wonders if it was her old life that was the dream, and if this nightmare is what her life has always been.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "Brief moment of nearly human remorse, but there’s no value in remorse, nothing but a weakness that others will inevitably find and exploit.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "I’ll show you who you’re looking for.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "The man is grinning, a smile that holds everything unpredictable and unavoidable in the world.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "\u2026His need for her outweighs his need to live.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "If I don’t love this girl, then maybe I’ve never loved anyone.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "A moment later, she’s dancing alone, arms and hips creating art where a moment before there was empty space.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "Pain. She wants the word to have more letters in it, too short of a word to encompass what she’s feeling.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "She’s too young to know when to lie and when to tell the truth, how to hide her facial expressions and when to show them.",
      "author": "William Wager",
      "source": "The Ingénue"
  },
  {
      "quote": "Fear’s good. Makes stupid people think. Makes heroes cowards, but cowards live to see tomorrow.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "Everyone deserves a moment like that from time to time, I guess.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "Ain’t nothing to talk about. You play, you pay. That’s it. Nothing more to it than that.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "You got steam. You got guts, no doubt. But the game you’re playing, you need to be the best.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "It might not be mine, but it was still home.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "We ate, smoked, and talked about nothing, which was nice for once.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "Her eyes said, Stay. Mine told her, Not a chance.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "Thank God they didn’t take your common sense away.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "I’ll drive so smoothly you’ll think you’re riding on bacon grease.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "Dreams were for losers. Dreams were for the forgotten.",
      "author": "Ian Klink",
      "source": "Lucky"
  },
  {
      "quote": "We didn’t fall in love. We were always in it. We started in the middle, right in the chaos of it.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Words became weapons, and once we started fighting with weapons, we didn’t know how to resolve wars without them.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I wished I could preserve us and press us into a book, like a flower.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Death was a guarantee, but loss was a birthright. No one lived without losing.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Change stays subtle until you can’t ignore it.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Why does nobody ever talk about healed people healing people?",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "My broken pieces fit with yours.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "You’re handing me a knife when I already know what sharp edges feel like. I can’t.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "He used to be my universe. Now, he wasn’t even a star.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "It was the one fight where compromise felt like betrayal.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I wasn’t sure if I could play that part anymore, but I knew I could write a better ending.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "A pen or a keyboard was a lightning rod for the storm of my thoughts.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "There are wounds that don’t bleed.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "We rarely know how deep a hole we’re in until we try climbing out.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Days feel longer when you’re fighting with someone, but they feel frozen when you don’t even know what you’re doing with them.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I had fallen in love while falling out of it.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Sometimes, all you have to do is listen.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "If I’m your anchor, you’re my gust of wind.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "If I’m your peace, you’re my chaos.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I was a basket case. He was no one’s case.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Misplaced hope is how disappointment is created.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "He made falling feel safe.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I had been looking for the love I so desperately needed from others, and where had that gotten me? Lonely on the side of the road.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Maybe my heart was like a bone that needed an extra break to be reset completely.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Maybe the hand I needed to hold was my own.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I spoke more to my journal than I did out loud.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "Your heart doesn’t make the best decisions. That’s what your head is for. Both have to agree for it to be right.",
      "author": "Andrea Casanova",
      "source": "The Repercussions of Us"
  },
  {
      "quote": "I didn’t get a choice about what happened to me, but I do get to choose what to do with each day I have left.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Barrie isn’t the only world that exists. There are more out there, and they’re worth setting out for.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "No matter how far you travel, there are still people and places that you call home.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "“It doesn’t have to be historic to be home. Trust me.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Because even though life feels like a curse at times, there are bright moments that make it all worth it.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "I’m unlimited. And I can tell you that it’s better to feel that way than to live that way.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "I like not being alone. It’s a wonderful feeling.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Days passed, and Evie felt each one as if it were a small leaf falling from a tree—wondering how many were left on the branches, and which ones were the most meaningful.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Some things are just meant to last. I like to think we’re one of them.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "\u2026You can’t make a change or know what’s worth living for if you’re afraid.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "The moment I wish lasted forever. I don’t think I’ll ever have another moment like this.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "\u2026We’re not meant to live forever. We’re all put here for a purpose, for a time. We have to do the best we can with that time. That’s what makes it precious.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "You’ve lived your entire life in other people’s stories. I thought maybe it was time for a change. Let yourself be the author for once.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "If there’s one person with a story worth telling, it’s you.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "And maybe they choose to know each other, and stick together. Maybe not forever, but long enough to know that whatever lives they live—no matter how long or short—they were worth living.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "I lived my whole life in fairy tales and other people’s stories.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Maybe it’s time I actually share my own story.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "You gave me the story of a lifetime. You showed me that some magic is real.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Our story may be on hold, but it isn’t over, not yet.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "This isn’t just my story anymore, it’s ours.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "I found it—your book. Our book. I promise I’ll keep it safe. I think I might have a story or two that will make it in here soon. And who knows, maybe more will come with time.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "The remains of her summer took up what little space she had to fill.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Evie may have outgrown her old, crayon drawn self, but she had yet to outgrow the dreams she had, even then.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "For a moment, Evie felt like she was gliding, like she was finally free.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "Today was something new and unexpected. I’m getting used to both.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "And even if it wasn’t perfect, it still meant the world to us.",
      "author": "Louis Alvarez",
      "source": "This Isn’t The End"
  },
  {
      "quote": "I’ve learned that the world is darkness.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "Maybe they’re always there\u2026 Maybe you can only see them if you don’t look right at them.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "I guess that’s just part of being scared\u2026 Dealing with it.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "I don’t even know who ‘they’ are, and here I am following their life advice!",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "It’s probably better to know than not to, right?",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "Finally, they decided it was a ghost just to keep from fighting.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "Ethan had kept laughing, because if he stopped, he would have started shrieking, too.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "I should have been kinder. The curse was not his fault.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "They go a step further, and it ends in disaster for them\u2026 Will you follow in their footsteps, even forewarned?",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "It’s the ticking of your heartbeat, and it is becoming slower and slower.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "Even in the most careful cover-ups, something always slips through.",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "Well, who knows for sure what weird stuff is out there?",
      "author": "Jeff Provine",
      "source": "Never Sleep Again"
  },
  {
      "quote": "Genius is one percent inspiration and ninety-nine percent perspiration.",
      "author": "Thomas Edison"
  },
  {
      "quote": "If we wait until we’re ready we’ll be waiting for the rest of our lives.",
      "author": "Lemony Snicket",
      "source": "The Ersatz Elevator"
  },
  {
      "quote": "Behind every exquisite thing that existed, there was something tragic.",
      "author": "Oscar Wilde",
      "source": "The Picture of Dorian Gray"
  },
  {
      "quote": "By accepting a given world-view as absolute truth, people are scooping up a handful of sand and thereby ignoring the rest of the beach.",
      "author": "Stewart Wieck",
      "source": "Mage: The Ascension"
  },
  {
      "quote": "All the days ordained for me were written in your book before one of them came to be.",
      "source": "Psalms 139:16"
  },
  {
      "quoteLines": ["There once was a lit'rary miss;","And all that she needed for bliss","Was some ink and a pen,","Reams of paper, and then","Thirty days to describe half a kiss."],
      "author": "Oliver Marble",
      "source": "A Literary Miss"
  }
]

// Quote sources that map to a catalog book, by Shopify product `handle` (the
// same key Catalog.js opens its detail lightbox with). QuoteBubble links a
// quote's attribution to /catalog?book=<handle> when its `source` appears here.
// Sources not listed — Edison, Wilde, Snicket, Mage, Psalms, the limerick —
// render plain, with no link. Add a book here once and every quote from it links.
export const SOURCE_HANDLES = {
  'The Ingénue': 'the-ingenue-paperback-v2',
  'Lucky': 'lucky',
  'The Repercussions of Us': 'the-repercussions-of-us',
  'This Isn’t The End': 'this-isnt-the-end',
  'Never Sleep Again': 'never-sleep-again',
}

export default quotes
